export default __webpack_public_path__ + "static/media/IPRU_logo.702335fe.png";